/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'indicatorsArrow': {
    width: 16,
    height: 16,
    viewBox: '0 0 1024 1024',
    data: '<path pid="0" d="M780.716 560.132l-442.074 443.993a67.847 67.847 0 01-95.964-95.964L637.41 511.51 243.958 115.818a67.847 67.847 0 0195.964-95.964l440.794 444.953a67.495 67.495 0 010 95.325z" _fill="#2c2c2c"/>'
  }
})
